import Vue from 'vue';
import VueRouter from 'vue-router';
import SignIn from '@/views/SignIn.vue';
import firebase from 'firebase';
import BookmarkPage from '@/views/BookmarkPage.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'top',
    component: BookmarkPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/signin',
    name: 'signin',
    component: SignIn,
  },
  {
    path: '/bookmark',
    name: 'bookmark',
    component: BookmarkPage,
    meta: { requiresAuth: true },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (requiresAuth && !currentUser) {
    next('signin');
  } else {
    next();
  }
});

export default router;
